import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import Stack from "@mui/material/Stack";
import MDButton from "components/MDButton";
import { LojaPageContainer } from "../../common";
import ContasFinanceirasSection from "../dashboard/components/ContasFinanceirasSection";
import { useContasFinanceirasGerencial } from "../dashboard/hooks/useContasFinanceirasGerencial";
import { saveButtonSx } from "../components/contas-financeiras.theme";

/**
 * Cadastro de contas financeiras (banco, caixa, gateway) — extrato e baixa manual.
 */
export default function LojaFinanceiroContasFinanceirasPage() {
  const gerencial = useContasFinanceirasGerencial();

  return (
    <LojaPageContainer
      title="Contas financeiras"
      subtitle="Efí: recebimentos e taxas. Caixa: dinheiro repassado. Registre aqui o repasse depois de transferir no painel Efí."
      actions={
        <MDButton
          variant="gradient"
          color="dark"
          size="small"
          startIcon={<AddOutlinedIcon />}
          onClick={gerencial.abrirNova}
          sx={saveButtonSx}
        >
          Nova conta
        </MDButton>
      }
    >
      <Stack spacing={3}>
        <ContasFinanceirasSection gerencial={gerencial} />
      </Stack>
    </LojaPageContainer>
  );
}
